var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgPerson(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 32,
    height: 32,
    viewBox: "0 0 32 32",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M16.5791 16.6358C19.881 16.6358 22.5552 13.6261 22.5552 9.94134C22.5552 6.31282 19.881 3.42969 16.5791 3.42969C13.2909 3.42969 10.5893 6.35501 10.603 9.96947C10.6166 13.6402 13.2772 16.6358 16.5791 16.6358ZM16.5791 14.1746C14.6962 14.1746 13.0998 12.3322 13.0998 9.96947C13.0862 7.66297 14.6826 5.8909 16.5791 5.8909C18.4893 5.8909 20.0583 7.63484 20.0583 9.94134C20.0583 12.3041 18.4756 14.1746 16.5791 14.1746ZM8.06516 29.7154H25.0794C27.4398 29.7154 28.5723 28.9419 28.5723 27.2823C28.5723 23.4147 23.8923 18.2673 16.5791 18.2673C9.26584 18.2673 4.57227 23.4147 4.57227 27.2823C4.57227 28.9419 5.70473 29.7154 8.06516 29.7154ZM7.64219 27.2542C7.31473 27.2542 7.19194 27.1417 7.19194 26.8885C7.19194 24.7367 10.562 20.7285 16.5791 20.7285C22.5825 20.7285 25.9526 24.7367 25.9526 26.8885C25.9526 27.1417 25.8298 27.2542 25.5023 27.2542H7.64219Z",
    fill: "white"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPerson);
export default __webpack_public_path__ + "static/media/person.fd4b95be79a978166e84d1eace88da87.svg";
export { ForwardRef as ReactComponent };